import React from "react";
import { IGenericInfoPopupProps } from "halifax/build/GenericInfoPopup";
import { paymentTextConstants } from "halifax";
import { TokenizeCardErrors, RewardsAccount } from "redmond";
import { PaymentError } from "@capone/checkout";
import { Typography } from "@material-ui/core";
import {
  ADD_PAYMENT_METHOD_ERROR_TITLE,
  EDIT_PAYMENT_METHOD,
  TRY_AGAIN_CTA,
} from "./textConstants";

const defaultPaymentErrorProps = (
  isCorporate: boolean,
  clearErrors: () => void
) => ({
  title: isCorporate
    ? paymentTextConstants.ERROR_ADDING_PAYMENT_METHOD_TITLE
    : ADD_PAYMENT_METHOD_ERROR_TITLE,
  buttons: [
    {
      buttonText: isCorporate
        ? paymentTextConstants.EDIT_PAYMENT_INFO
        : TRY_AGAIN_CTA,
      onClick: clearErrors,
    },
  ],
});

export const getErrorModalProps = (
  tokenizeErrors: TokenizeCardErrors[],
  invalidCapOneCard: boolean,
  clearErrors: () => void,
  paymentError: PaymentError | undefined,
  rewardsAccount: RewardsAccount,
  isCorporate: boolean
): Pick<IGenericInfoPopupProps, "title" | "subtitle" | "buttons"> => {
  if (tokenizeErrors.length) {
    return {
      ...defaultPaymentErrorProps(isCorporate, clearErrors),
      subtitle: tokenizeErrors[0].message,
    };
  }

  if (invalidCapOneCard) {
    return {
      title: paymentTextConstants.CAP_ONE_INVALID_CREDIT_CARD_TITLE,
      subtitle:
        paymentTextConstants.CAP_ONE_INVALID_CREDIT_CARD_SUBTITLE("capone"),
      buttons: [{ buttonText: EDIT_PAYMENT_METHOD, onClick: clearErrors }],
    };
  }

  if (paymentError) {
    switch (paymentError.data) {
      case "UnknownCard":
        return isCorporate
          ? {
              title: paymentTextConstants.UNKNOWN_CARD_ERROR_TITLE,
              subtitle: (
                <Typography variant="inherit">
                  {paymentTextConstants.UNKNOWN_CARD_ERROR_SUBTITLE(
                    rewardsAccount,
                    "html"
                  )}
                </Typography>
              ),
              buttons: [
                {
                  buttonText: paymentTextConstants.ADD_NEW_PAYMENT_METHOD,
                  onClick: clearErrors,
                },
              ],
            }
          : defaultPaymentErrorProps(false, clearErrors);
      case "InvalidCVV":
        return {
          title: paymentTextConstants.CVV_ERROR_TITLE,
          subtitle: paymentTextConstants.CVV_ERROR_SUBTITLE,
          buttons: [
            {
              buttonText: paymentTextConstants.EDIT_PAYMENT_INFO,
              onClick: clearErrors,
            },
          ],
        };
      case "InvalidAddress":
        return {
          title: paymentTextConstants.INVALID_ADDRESS_ERROR_TITLE,
          subtitle: paymentTextConstants.INVALID_ADDRESS_ERROR_SUBTITLE,
          buttons: [
            {
              buttonText: paymentTextConstants.EDIT_PAYMENT_INFO,
              onClick: clearErrors,
            },
          ],
        };
      default:
        return defaultPaymentErrorProps(false, clearErrors);
    }
  }

  return defaultPaymentErrorProps(isCorporate, clearErrors);
};
